import React, { useEffect, useState } from 'react';

const Theme = () => {
  const theme = localStorage.getItem('theme');
  const [currentTheme, setCurrentTheme] = useState(theme || 'dark');
  const themeText = ['☀️', '🌑']

  useEffect(() => {
    localStorage.setItem('theme', currentTheme);
    document.documentElement.style.setProperty(
      '--text-color',
      currentTheme === 'dark' ? 'white' : 'black'
    );
    document.documentElement.style.setProperty(
      '--background-color',
      currentTheme === 'dark' ? '#0A2463' : '#A8D8EA'
    );
    document.documentElement.style.setProperty(
      '--hr-color',
      currentTheme === 'dark' ? 'white' : '#333333'
    )
    document.documentElement.style.setProperty(
      '--navbar-background',
      currentTheme === 'dark' ? 'rgba(20, 20, 20, 0.7)' : 'rgba(155, 206, 221, 0.85)'
    );
    document.documentElement.style.setProperty(
      '--navbar-border-bottom',
      currentTheme === 'dark' ? '2px solid #FFD700' : '1px solid rgba(173, 216, 230, 0.4)'
    );
    document.documentElement.style.setProperty(
      '--navbar-box-shadow',
      currentTheme === 'dark' ? '0 4px 15px rgba(0, 0, 0, 0.3)' : '0 2px 10px rgba(3, 62, 85, 0.7)'
    );
    document.documentElement.style.setProperty(
      '--navbar-text-color',
      currentTheme === 'dark' ? 'white' : 'white'
    );
    document.documentElement.style.setProperty(
      '--hover-color',
      currentTheme === 'dark' ? 'rgb(155, 206, 221)' : 'rgb(20, 20, 20)'
    );
    document.documentElement.style.setProperty(
      '--background-opacity',
      currentTheme === 'dark' ? '1' : '0.5'
    );
    if(currentTheme === 'dark'){
      document.getElementById('blackIcon').style.visibility='hidden';
      document.getElementById('whiteIcon').style.visibility='visible';
      document.getElementById('darkBackgroundImg').style.visibility='visible';
      document.getElementById('lightBackgroundImg').style.visibility='hidden';
    }
    else{
      document.getElementById('blackIcon').style.visibility='visible';
      document.getElementById('whiteIcon').style.visibility='hidden'; 
      document.getElementById('lightBackgroundImg').style.visibility='visible';
      document.getElementById('darkBackgroundImg').style.visibility='hidden';
    }

  }, [currentTheme]);

  return (
    <button
      className="theme"
      onClick={() =>
        setCurrentTheme(currentTheme === 'dark' ? 'light' : 'dark')
      }
    >
      {themeText[currentTheme === 'dark' ? 1 : 0]}
    </button>
  );
};

export default Theme;
